<template>
    <div class="section text-center mt-1" v-if="loading_list">
        <div class="spinner-border text-primary" role="status"></div>
    </div>
    <div class="section pt-0 mt-0" v-if="!loading_list && !this.$route.path.includes('call-follow-up-edit-v2')">
        <div class="listed-detail mt-1 page-title">
            <h3 class="text-center mt-1 mal-text custom-title">{{ responseData.campign.name }}</h3>
        </div>
    </div>
    <div class="section mb-1 mt-1" v-if="!loading_list && responseData.permissions.report && !searchResponse.contact">
        <div class="transactions">
            <a :href="'/#/call-follow-up-report-v2/' + responseData.campign.id" class="item compact-item">
                <div class="detail">
                    <img :src="'assets/img/telephone.png'" alt="img" class="image-block imaged w32">
                    <div>
                        <strong class="text-primary">Calling Report</strong>
                    </div>
                </div>
                <div class="right">
                    <div class="price text-primary"><ion-icon name="chevron-forward-outline"></ion-icon></div>
                </div>
            </a>
            <a href="javascript:void(0)" @click="goToMentorManagement" class="item compact-item">
                <div class="detail">
                    <img :src="'assets/img/user-star.png'" alt="img" class="image-block imaged w32" onerror="this.src='assets/img/sample/avatar/avatar1.png'">
                    <div>
                        <strong class="text-primary">Assign Mentors</strong>
                    </div>
                </div>
                <div class="right">
                    <div class="price text-primary"><ion-icon name="chevron-forward-outline"></ion-icon></div>
                </div>
            </a>
        </div>
    </div>
    <div class="section mb-1" v-if="!loading_list && !searchResponse.contact">
        <div class="row mt-1">
            <div class="col-6">
                <div class="stat-box">
                    <div class="title mal-text">ആകെ നമ്പറുകൾ</div>
                    <div class="value text-success">{{ responseData.target ? responseData.target : '0' }}</div>
                </div>
            </div>
            <div class="col-6">
                <div class="stat-box">
                    <div class="title mal-text">ബാക്കിയുള്ളത്(<a href="javascript:void(0)" data-bs-toggle="modal"
                            data-bs-target="#pendingListModel">List</a>)</div>
                    <div class="value text-danger">{{ responseData.balance ? responseData.balance : '0' }}</div>
                </div>
            </div>
        </div>
    </div>
    <div id="search" v-if="!loading_list && !this.$route.path.includes('call-follow-up-edit-v2')">
        <form class="search-form" @submit.prevent="search">
            <div class="row">
                <div class="input-group form-group" style="width:70% !important;padding-right: 0px;">
                    <input type="number" placeholder="Search Mobile..." class="form-control" maxlength="99999999999" focus
                        v-model="search_qry" aria-describedby="basic-addon3"
                        style="border: 1px solid #1a418c; border-radius: 10px;" />
                </div>
                <div class="form-group" style="width:12% !important;">
                    <button type="button" class="btn btn-icon btn-outline-success me-1" @click="search()">
                        <ion-icon name="search-outline" role="img" class="md hydrated"
                            aria-label="newspaper outline"></ion-icon>
                    </button>
                </div>
                <div class="form-group" style="width:12% !important;">
                    <button type="button" class="btn btn-icon btn-outline-primary me-1" @click="displayAll">
                        <ion-icon name="list-outline" role="img" class="md hydrated"
                            aria-label="newspaper outline"></ion-icon>
                    </button>
                </div>
            </div>
        </form>
    </div>
    <div class="section pt-0 mt-0" v-if="searchResponse.message">
        <div class="listed-detail mt-1">
            <h4 class="text-center text-danger mt-1 mal-text">{{ searchResponse.message }}</h4>
        </div>
    </div>
    <div class="section pt-0 mt-0" v-if="showContactAlternativesList && validContactsList.length > 0">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title text-warning">Available Contacts</h4>
                <p class="card-text mal-text">ആവശ്യമുള്ള കോൺടാക്ട് കണ്ടെത്താനായില്ല. ലഭ്യമായ കോൺടാക്റ്റുകൾ:</p>
            </div>
            <div class="card-body">
                <ul class="listview image-listview">
                    <li v-for="(contact, index) in validContactsList" :key="contact.id">
                        <a href="javascript:void(0)" class="item" @click="selectValidContact(contact)">
                            <span class="sl-no">{{ index + 1 }}</span>
                            <div class="in">
                                <div>
                                    <strong class="text-primary">{{ contact.name }} (ID: {{ contact.id }})</strong>
                                    <p class="text-muted">Mobile: {{ contact.mobile || 'N/A' }}</p>
                                </div>
                            </div>
                        </a>
                    </li>
                </ul>
                <button type="button" class="btn btn-secondary btn-block mt-2" @click="hideContactAlternatives">
                    Close
                </button>
            </div>
        </div>
    </div>
    <ul class="listview image-listview inset text mb-2" v-if="!loading_list && !searchResponse.contact && !search_loading">
        <li v-for="(member_list, index) in responseData.all_contacts" v-bind:key="member_list.id"
            :style="{ 'background-color': background }">
            <a href="javascript:void(0)" class="item" @click="gotoEditWithData(member_list)">
                <span class="sl-no">{{ index + 1 }}</span>
                <div class="avatar-section">
                    <a href="javascript:void(0)" @click.stop>
                        <img src="assets/img/sample/avatar/avatar1.png" alt="avatar" class="image">
                        <span class="button verified" v-if="member_list.status == 'Completed'">
                            <ion-icon name="checkmark-outline"></ion-icon>
                        </span>
                        <span class="button not-verified" v-if="member_list.status != 'Completed'">
                            <ion-icon name="close-outline"></ion-icon>
                        </span>
                    </a>
                </div>
                <div class="in">
                    <div class="min-width-50">
                        <header class="text-info" v-if="member_list.registered == 'Y' || member_list.registered == 1 || member_list.registered == '1'">Registered <span v-if="member_list.self_confirmation_status == 'Y'" class="text-info">| Self Confirmed</span></header>
                        <header class="text-danger" v-else>Not Registered <span v-if="member_list.self_confirmation_status == 'Y'" class="text-info">| Self Confirmed</span></header>
                        <b class="text-primary"> {{ member_list.name }} -{{ member_list.mobile }} </b>
                        <footer
                            :class="member_list.calling_status_value ? member_list.calling_status_value.item_value_display : 'text-primary'">
                            {{
                                member_list.calling_status_value ? member_list.calling_status_value.name_mal :
                                member_list.calling_status
                            }}
                        </footer>
                    </div>
                </div>
            </a>
        </li>
    </ul>

    <!-- Edit Page with Three Card Sections -->
    <div v-if="(searchResponse.contact && !search_loading) && !form_data_loading" class="section pt-0 mt-1 pb-2">
        <!-- Basic Details Card -->
        <div class="card mb-2">
            <div class="card-body basic-details-body">
                <!-- Profile Header: Picture, Name, Mobile (Top Left) -->
                <div class="profile-header-compact mb-2" v-if="searchResponse.contact">
                    <div class="profile-header-main">
                        <div class="avatar-section-compact">
                            <img v-if="searchResponse.contact.avatar && searchResponse.contact.avatar != 'member.jpg' && searchResponse.contact.avatar != null"
                                :src="'https://guide.msoftit.com/' + searchResponse.contact.avatar" 
                                alt="avatar" 
                                class="profile-avatar-compact rounded-circle">
                            <img v-else
                                src="assets/img/sample/avatar/avatar1.png" 
                                alt="avatar" 
                                class="profile-avatar-compact rounded-circle">
                        </div>
                        <div class="profile-info-compact">
                            <div class="profile-name-compact" v-if="isBasicFieldEnabled('b_name')">
                                {{ formData.b_name || formData.name || searchResponse.contact?.b_name || searchResponse.contact?.name || '-' }}
                            </div>
                            <div class="profile-mobile-compact" v-if="isBasicFieldEnabled('b_mobile') && (formData.b_mobile || formData.mobile || searchResponse.contact?.b_mobile || searchResponse.contact?.mobile)">
                                {{ formData.b_mobile || formData.mobile || searchResponse.contact?.b_mobile || searchResponse.contact?.mobile }}
                            </div>
                        </div>
                    </div>
                    <div class="profile-header-actions" v-if="isBasicFieldEnabled('b_mobile') && (formData.b_mobile || formData.mobile || searchResponse.contact?.b_mobile || searchResponse.contact?.mobile)">
                        <a
                            :href="'tel:' + (formData.b_mobile || formData.mobile || searchResponse.contact?.b_mobile || searchResponse.contact?.mobile)"
                            class="btn btn-link btn-icon header-call-btn"
                        >
                            <ion-icon name="call-outline"></ion-icon>
                        </a>
                        <a
                            :href="'https://wa.me/' + mobileToWhatsapp(formData.b_mobile || formData.mobile || searchResponse.contact?.b_mobile || searchResponse.contact?.mobile) + '?text='"
                            class="btn btn-link btn-icon header-whatsapp-btn"
                        >
                            <ion-icon name="logo-whatsapp"></ion-icon>
                        </a>
                    </div>
                </div>

                <!-- Icon + Text Grid for Other Fields -->
                <div class="basic-inline-grid">
                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_gender') && (getBasicFieldValue('b_gender') || formData.gender || searchResponse.contact?.gender)">
                        <ion-icon name="male-female-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">{{ getGenderLabel(getBasicFieldValue('b_gender') || formData.gender || searchResponse.contact?.gender) }}</span>
                    </div>
                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_age') && (getBasicFieldValue('b_age') || formData.age || searchResponse.contact?.age)">
                        <ion-icon name="hourglass-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">{{ getBasicFieldValue('b_age') || formData.age || searchResponse.contact?.age }}</span>
                    </div>
                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_membership_status') && searchResponse.contact?.is_member !== undefined">
                        <ion-icon name="card-outline" class="basic-inline-icon"></ion-icon>
                        <div
                            class="membership-badge"
                            :class="searchResponse.contact.is_member == 1 || searchResponse.contact.is_member == true || searchResponse.contact.is_member === '1' ? 'text-success' : 'text-danger'"
                        >
                            {{ searchResponse.contact.is_member == 1 || searchResponse.contact.is_member == true || searchResponse.contact.is_member === '1' ? 'Member' : 'Not Member' }}
                        </div>
                    </div>

                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_whatsapp') && (getBasicFieldValue('b_whatsapp') || formData.whatsapp || searchResponse.contact?.whatsapp)">
                        <ion-icon name="logo-whatsapp" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">{{ getBasicFieldValue('b_whatsapp') || formData.whatsapp || searchResponse.contact?.whatsapp }}</span>
                    </div>
                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_job') && (getBasicFieldValue('b_job') || formData.job || searchResponse.contact?.job)">
                        <ion-icon name="briefcase-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">{{ getBasicFieldValue('b_job') || formData.job || searchResponse.contact?.job }}</span>
                    </div>
                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_member_id') && (getBasicFieldValue('b_member_id') || formData.member_id || searchResponse.contact?.member_id)">
                        <ion-icon name="id-card-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">{{ getBasicFieldValue('b_member_id') || formData.member_id || searchResponse.contact?.member_id }}</span>
                    </div>

                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_place') && (getBasicFieldValue('b_place') || formData.place || searchResponse.contact?.place)">
                        <ion-icon name="home-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">{{ getBasicFieldValue('b_place') || formData.place || searchResponse.contact?.place }}</span>
                    </div>
                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_district') && getDistrictName(getBasicFieldValue('b_district') || formData.district_id || searchResponse.contact?.district_id)">
                        <ion-icon name="map-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">{{ getDistrictName(getBasicFieldValue('b_district') || formData.district_id || searchResponse.contact?.district_id) }}</span>
                    </div>
                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_zone') && getZoneName(getBasicFieldValue('b_zone') || formData.zone_id || searchResponse.contact?.zone_id)">
                        <ion-icon name="navigate-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">{{ getZoneName(getBasicFieldValue('b_zone') || formData.zone_id || searchResponse.contact?.zone_id) }}</span>
                    </div>

                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_unit') && getUnitName(getBasicFieldValue('b_unit') || formData.unit_id || searchResponse.contact?.unit_id)">
                        <ion-icon name="business-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">{{ getUnitName(getBasicFieldValue('b_unit') || formData.unit_id || searchResponse.contact?.unit_id) }}</span>
                    </div>
                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_wing') && getWingLabel(getBasicFieldValue('b_wing') || formData.wing || searchResponse.contact?.wing)">
                        <ion-icon name="people-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">{{ getWingLabel(getBasicFieldValue('b_wing') || formData.wing || searchResponse.contact?.wing) }}</span>
                    </div>
                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_education') && (getBasicFieldValue('b_education') || formData.education || searchResponse.contact?.education || searchResponse.contact?.b_education)">
                        <ion-icon name="school-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">
                            {{ searchResponse.contact?.b_education_name || searchResponse.contact?.education_name || getEducationName(getBasicFieldValue('b_education') || formData.education || searchResponse.contact?.education || searchResponse.contact?.b_education) || getBasicFieldValue('b_education') || formData.education || searchResponse.contact?.education || searchResponse.contact?.b_education }}
                        </span>
                    </div>

                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_institution') && (getBasicFieldValue('b_institution') || formData.institution || searchResponse.contact?.institution)">
                        <ion-icon name="library-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">{{ getBasicFieldValue('b_institution') || formData.institution || searchResponse.contact?.institution }}</span>
                    </div>
                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_background') && (getBasicFieldValue('b_background') || formData.background || formData.background_summery || searchResponse.contact?.background || searchResponse.contact?.background_summery)">
                        <ion-icon name="information-circle-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">{{ getBasicFieldValue('b_background') || formData.background || formData.background_summery || searchResponse.contact?.background || searchResponse.contact?.background_summery }}</span>
                    </div>
                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_org_positions') && isMember() && getBasicFieldValue('b_org_positions')">
                        <ion-icon name="medal-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text" style="word-break: break-word; line-height: 1.4;">{{ getBasicFieldValue('b_org_positions') }}</span>
                    </div>
                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_org_departments') && isMember() && getBasicFieldValue('b_org_departments')">
                        <ion-icon name="git-network-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text" style="word-break: break-word; line-height: 1.4;">{{ getBasicFieldValue('b_org_departments') }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Summary / History Tabs -->
        <div class="section mt-1 mb-1 detail-tabs-wrapper">
            <ul class="nav nav-tabs lined detail-tabs" role="tablist">
                <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: activeDetailTab === 'summary' }"
                        href="javascript:void(0)"
                        role="tab"
                        @click="setDetailTab('summary')"
                    >
                        Summary
                    </a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: activeDetailTab === 'history' }"
                        href="javascript:void(0)"
                        role="tab"
                        @click="setDetailTab('history')"
                    >
                        History
                    </a>
                </li>
            </ul>
        </div>

        <!-- Survey Card (Summary Tab) -->
        <div class="card mb-2" v-if="activeDetailTab === 'summary'">
            <div class="card-body">
                <Form @submit="handleRegistration" ref="veeForm">
                    <div class="form-group basic" v-for="field in enabledFields" :key="field.id">
                        <div class="input-wrapper">
                            <label class="label text-primary" :for="field.column_id">
                                {{ field.label }}
                                <span class="text-danger" v-if="field.required">*</span>
                            </label>
                            <template v-if="field.type === 'Select'">
                                <select
                                    class="form-control custom-select"
                                    :name="field.column_id"
                                    v-model="formData[field.column_id]"
                                    :required="field.required"
                                >
                                    <option value="">Select {{ field.label }}</option>
                                    <option v-for="option in getFieldOptions(field)" :key="option.value" :value="option.value">
                                        {{ option.label }}
                                    </option>
                                </select>
                            </template>
                            <template v-else-if="field.type === 'Radio'">
                                <div class="radio-group">
                                    <div v-for="option in getFieldOptions(field)" :key="option.value" class="form-check">
                                        <input
                                            type="radio"
                                            class="form-check-input"
                                            :id="field.column_id + '_' + option.value"
                                            :name="field.column_id"
                                            :value="option.value"
                                            v-model="formData[field.column_id]"
                                            :required="field.required"
                                        />
                                        <label :for="field.column_id + '_' + option.value" class="form-check-label">
                                            {{ option.label }}
                                        </label>
                                    </div>
                                </div>
                            </template>
                            <template v-else-if="field.type === 'Checkbox'">
                                <div class="checkbox-group">
                                    <div v-for="option in getFieldOptions(field)" :key="option.value" class="form-check">
                                        <input
                                            type="checkbox"
                                            class="form-check-input"
                                            :id="field.column_id + '_' + option.value"
                                            :name="field.column_id + '_' + option.value"
                                            :value="option.value"
                                            :checked="isCheckboxChecked(field.column_id, option.value)"
                                            @change="handleCheckboxChange(field.column_id, option.value, $event)"
                                            :required="field.required"
                                        />
                                        <label :for="field.column_id + '_' + option.value" class="form-check-label">
                                            {{ option.label }}
                                        </label>
                                    </div>
                                </div>
                            </template>
                            <template v-else-if="field.type === 'textarea'">
                                <textarea
                                    class="form-control"
                                    :name="field.column_id"
                                    v-model="formData[field.column_id]"
                                    :placeholder="field.label"
                                    :required="field.required"
                                ></textarea>
                            </template>
                            <template v-else>
                                <input
                                    :type="field.type === 'Number' ? 'number' : field.type === 'time' ? 'time' : field.type === 'datetime-local' ? 'datetime-local' : 'text'"
                                    class="form-control"
                                    :name="field.column_id"
                                    v-model="formData[field.column_id]"
                                    :placeholder="field.label"
                                    :required="field.required"
                                    autocomplete="off"
                                />
                            </template>
                            <span class="error-feedback" v-if="field.required && !formData[field.column_id]" style="display: none;">
                                This field is required
                            </span>
                        </div>
                    </div>

                    <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="btn_loading">
                        <span v-show="btn_loading" class="spinner-border spinner-border-sm"></span>
                        <span>Save</span>
                    </button>
                </Form>
            </div>
        </div>

        <!-- History Card (History Tab) -->
        <div class="card mb-2" v-if="activeDetailTab === 'history'">
            <div class="card-body call-history-card">
                <div class="call-history-header">
                    <span class="call-history-title">Call History</span>
                </div>

                <div v-if="callHistoryList && callHistoryList.length">
                    <ul class="call-history-list">
                        <li v-for="(item, index) in callHistoryList" :key="index" class="call-history-item">
                            <div class="call-history-timeline">
                                <span class="call-history-dot" :class="{ 'active': index === 0 }"></span>
                                <span
                                    v-if="index !== callHistoryList.length - 1"
                                    class="call-history-line"
                                ></span>
                            </div>
                            <div class="call-history-content">
                                <div class="call-history-entry">
                                    <div class="call-history-entry-header">
                                        <div class="call-history-main">
                                            {{ formatCallHistoryMain(item) }}
                                        </div>
                                        <div class="call-history-duration" v-if="item.duration">
                                            {{ item.duration }}
                                        </div>
                                        <ion-icon name="chevron-down-outline" class="call-history-chevron"></ion-icon>
                                    </div>

                                    <div class="call-history-meta" v-if="formatCallHistoryMeta(item) || item.caller">
                                        <span v-if="item.caller">Caller: {{ item.caller }}</span>
                                        <span v-if="formatCallHistoryMeta(item)" class="dot-separator">
                                            {{ formatCallHistoryMeta(item) }}
                                        </span>
                                    </div>

                                    <div class="call-history-section" v-if="item.conversation_log">
                                        <span class="call-history-section-label">Conversation Log:</span>
                                        <span class="call-history-section-text">{{ item.conversation_log }}</span>
                                    </div>

                                    <div class="call-history-section" v-if="item.notes">
                                        <span class="call-history-section-label">Notes:</span>
                                        <span class="call-history-section-text">{{ item.notes }}</span>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>

                <div v-else class="text-center py-2">
                    <p class="text-muted mb-0">No previous call history available.</p>
                </div>
            </div>
        </div>
    </div>

    <!-- Pending List Modal -->
    <div class="modal fade action-sheet" id="pendingListModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Pending List</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <ul class="listview image-listview inset">
                            <li v-for="(member, index) in this.pending_contacts" v-bind:key="member.id">
                                <a href="javascript:void(0)" class="item">
                                    <span class="sl-no">{{ (index + 1) }}</span>
                                    &nbsp;&nbsp;
                                    <div class="in">
                                        <div>
                                            <header class="text-info" v-if="member.registered == 'Y' || member.registered == 1 || member.registered == '1'">Registered</header>
                                            <b class="list-item-text">{{ member.name }}({{ member.contact_id }})</b>
                                            <footer>
                                                <span class="text-primary">
                                                    {{ member.mobile ? member.mobile : 'No Number' }}
                                                </span>
                                            </footer>
                                        </div>
                    <div class="card-button">
                                            <button type="button" data-bs-dismiss="modal" class="btn btn-link btn-icon"
                                                @click="gotoEdit(member.mobile)">
                                                <ion-icon name="eye-outline"></ion-icon>
                                            </button>
                                        </div>
                                    </div>
                                </a>
                            </li>
                        </ul>
                        <div class="form-group basic">
                            <button type="button" data-bs-dismiss="modal"
                                class="btn btn-secondary btn-cancel btn-lg col-12">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <alert-model :type="alert_type" :message="alert_message" :redirectRoute="alertRedirectRoute" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params"
        ref="dialog_model"></dialog-model>
</template>

<script>
import {
    Form
} from "vee-validate";
import { defineRule } from 'vee-validate';
import UserService from "../../services/user.service";
import $ from "jquery";
import AlertModel from "./../layouts/AlertModel.vue";
import DialogModel from "./../layouts/DialogModel.vue";

// Define validation rules
defineRule('required', value => {
    // Treat 0 and '0' as valid values (for Yes/No fields)
    if (value === 0 || value === '0') {
        return true;
    }
    // Check for null, undefined, empty string, or empty array
    if (value === null || value === undefined || value === '') {
        return 'This field is required';
    }
    if (typeof value === 'string' && !value.trim()) {
        return 'This field is required';
    }
    if (Array.isArray(value) && !value.length) {
        return 'This field is required';
    }
    return true;
});

export default {
    name: "CallFollowUpV2Edit",
    props: {
        unit_id: null,
        permissions: Object,
    },
    components: {
           Form,
           AlertModel,
           DialogModel,
    },
    data() {
        return {
            btn_loading: false,
            search_loading: false,
            loading: false,
            loading_list: false,
            form_data_loading: false,
            search_qry: '',
            alert_type: "",
            alert_message: "",
            dialog_message: "",
            dialog_action: "",
            dialog_action_params: null,
            fields: [],
            basicFields: [], // Store basic fields separately
            formData: {
                name: '',
                mobile: '',
                mobile2: '',
                whatsapp: '',
                comments: '',
                status: '',
                calling_status: '',
                calling_status_temp: '', // For temporary storage
            },
            questians_responses: [],
            responseData: {
                campign: [],
                questians: [],
                all_contacts: [],
                permissions: []
            },
            searchResponse: {
                contact: ''
            },
            pending_contacts: [],
            district_list: [],
            zone_list: [],
            unit_list: [],
            status_list: [],
            country_code_list: [],
            tempMemberData: null,
            showContactAlternativesList: false,
            validContactsList: [],
            alertRedirectRoute: '',
            activeDetailTab: 'summary',
            educationCache: {}, // Cache for education names
            educationLoading: false, // Flag to prevent multiple API calls
        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        enabledFields() {
            // Only include regular fields (not basic fields) for the Summary form
            // Basic fields (starting with 'b_') are shown in the Basic Details Card only
            return (this.fields || [])
                .filter(field => field.enabled)
                .sort((a, b) => (a.order || 0) - (b.order || 0));
        },
        schema() {
            const validationRules = {};
            this.fields.forEach(field => {
                if (field.enabled && field.required) {
                    validationRules[field.column_id] = 'required';
                }
            });
            return validationRules;
        }
    },

    watch: {
        status_list: {
            handler(newVal, oldVal) {
                if (Array.isArray(newVal) && newVal.length > 0 && (!oldVal || oldVal.length === 0)) {
                    console.log('Status list loaded, checking for stored calling_status');

                    let storedStatus = this.formData.calling_status_temp ||
                                     this.searchResponse?.contact?.calling_status ||
                                     this.formData.calling_status;

                    if (storedStatus && storedStatus !== '') {
                        console.log('Found stored calling_status:', storedStatus);
                        const mapped = this.mapCallingStatus(storedStatus);
                        console.log('Mapped to:', mapped);

                        if (mapped && mapped !== '') {
                            this.formData.calling_status = mapped;
                            this.$nextTick(() => {
                                this.$forceUpdate();
                            });
                        }
                    }
                }
            },
            immediate: true,
            deep: true
        },
        'formData.district_id'(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.fetchZones(newVal);
            }
        },
        'formData.b_district'(newVal, oldVal) {
            if (newVal !== oldVal && newVal) {
                this.fetchZones(newVal);
            }
        },
        'formData.zone_id'(newVal, oldVal) {
            if (newVal !== oldVal && newVal) {
                this.fetchUnits(newVal);
            }
        },
        'formData.b_zone'(newVal, oldVal) {
            if (newVal !== oldVal && newVal) {
                this.fetchUnits(newVal);
            }
        }
    },

    mounted() {
        if (!this.currentUser) {
            location.replace("/");
        } else {
            this.$root.updateParent("Loading...");
            // Debug watcher for test_field value changes
            this.$watch(
                () => this.formData.test_field,
                (newVal, oldVal) => {
                    console.log('test_field value changed:', oldVal, '=>', newVal);
                }
            );
            this.loading_list = true;

            Promise.all([
                this.getComboboxValues('CALL_CAMPAIGN_STATUS'),
                this.getComboboxValues('COUNTRY_CODE'),
                this.getCampign()
            ]).then(() => {
                const storedMemberData = localStorage.getItem('editMemberData');
                if (storedMemberData) {
                    this.loadStoredMemberData(JSON.parse(storedMemberData));
                    localStorage.removeItem('editMemberData');
                }
            }).catch(() => {
                this.loading_list = false;
            });
        }

        window.onpopstate = function () {
            if ($("body").hasClass("modal-open")) {
                location.reload();
            }
        };
    },

    methods: {
        getCampign() {
            return new Promise((resolve, reject) => {
                let data = {
                    id: this.$route.params.id,
                    mobile: this.$route.params.mobile ? this.$route.params.mobile : null
                }

                const campaignPromise = UserService.authPostRequest('v2/get-call-campign', data);
                const fieldsPromise = UserService.authPostRequest('v2/get-call-campign-fields', {
                    campaign_id: this.$route.params.id
                });

                Promise.all([campaignPromise, fieldsPromise]).then(([campaignResponse, fieldsResponse]) => {
                    if (campaignResponse.data.status === 'success') {
                        this.loading_list = false;
                        this.responseData = campaignResponse.data.data;
                        this.pending_contacts = campaignResponse.data.data.pending_contacts;
                        this.all_contacts = campaignResponse.data.data.all_contacts;
                        this.district_list = campaignResponse.data.data.district;

                        if (fieldsResponse.data.status === 'success') {
                            // Handle basic fields
                            if (fieldsResponse.data.data.basic_fields && fieldsResponse.data.data.basic_fields.length > 0) {
                                console.log('Basic fields from API:', fieldsResponse.data.data.basic_fields);
                                
                                this.basicFields = fieldsResponse.data.data.basic_fields.map(field => {
                                    let fieldType = field.type ? this.mapBackendFieldType(field.type) : this.determineFieldType(field.column_id);
                                    
                                    let options = field.options;
                                    if (options && typeof options === 'string') {
                                        try {
                                            options = JSON.parse(options);
                                        } catch (e) {
                                            console.log('Could not parse options for', field.column_id);
                                        }
                                    }
                                    
                                    return {
                                        ...field,
                                        type: fieldType,
                                        options: options
                                    };
                                });
                                
                                // Initialize formData for basic fields
                                this.basicFields.forEach(field => {
                                    if (field.type === 'Checkbox') {
                                        this.formData[field.column_id] = [];
                                    } else {
                                        this.formData[field.column_id] = '';
                                    }
                                    
                                    // Handle special cases for basic fields
                                    if (field.column_id === 'b_wing') {
                                        this.formData[field.column_id + '_text'] = '';
                                    }
                                    if (field.type === 'Number' && field.column_id === 'b_mobile') {
                                        this.formData[field.column_id + '_country_code'] = '+91';
                                    }
                                });
                            }
                            
                            // Handle regular fields
                            if (fieldsResponse.data.data.fields && fieldsResponse.data.data.fields.length > 0) {
                                console.log('Fields from API:', fieldsResponse.data.data.fields);

                                this.fields = fieldsResponse.data.data.fields.map(field => {
                                    // Use backend field type first, then fallback to determination
                                    let fieldType = field.type ? this.mapBackendFieldType(field.type) : this.determineFieldType(field.column_id);

                                    // Parse options if string
                                    let options = field.options;
                                    if (options && typeof options === 'string') {
                                        try {
                                            options = JSON.parse(options);
                                        } catch (e) {
                                            console.log('Could not parse options for', field.column_id);
                                        }
                                    }

                                    return {
                                        ...field,
                                        type: fieldType,
                                        options: options
                                    };
                                });

                                // Initialize formData for regular fields
                                this.fields.forEach(field => {
                                    // Initialize checkbox fields as arrays
                                    if (field.type === 'Checkbox') {
                                        this.formData[field.column_id] = [];
                                    } else {
                                        this.formData[field.column_id] = '';
                                    }

                                    if (field.column_id === 'wing') {
                                        this.formData[field.column_id + '_text'] = '';
                                    }
                                    if (field.type === 'Number' &&
                                        ['mobile2', 'whatsapp', 'mobile_new'].includes(field.column_id)) {
                                        this.formData[field.column_id + '_country_code'] = '+91';
                                    }
                                });
                            }
                            
                            // Also handle all_fields if provided (for backward compatibility)
                            if (fieldsResponse.data.data.all_fields && fieldsResponse.data.data.all_fields.length > 0) {
                                const allFields = fieldsResponse.data.data.all_fields.map(field => {
                                    let fieldType = field.type ? this.mapBackendFieldType(field.type) : this.determineFieldType(field.column_id);
                                    
                                    let options = field.options;
                                    if (options && typeof options === 'string') {
                                        try {
                                            options = JSON.parse(options);
                                        } catch (e) {
                                            console.log('Could not parse options for', field.column_id);
                                        }
                                    }
                                    
                                    return {
                                        ...field,
                                        type: fieldType,
                                        options: options
                                    };
                                });
                                
                                // Separate into basic and regular if not already separated
                                if (this.basicFields.length === 0 && this.fields.length === 0) {
                                    this.basicFields = allFields.filter(f => f.column_id && f.column_id.startsWith('b_'));
                                    this.fields = allFields.filter(f => !f.column_id || !f.column_id.startsWith('b_'));
                                }
                            }
                        }

                        if (this.tempMemberData) {
                            this.populateFormDirectly(this.tempMemberData);
                            this.tempMemberData = null;
                        }

                        this.$root.updateParent('Call Campaign');
                        resolve();
                    } else {
                        this.loading_list = false;
                        this.alert_type = 'Error';
                        this.alert_message = campaignResponse.data.message || 'Failed to load campaign data';
                        this.$refs.alert_model.openModel();
                        reject();
                    }
                }).catch((error) => {
                    this.loading_list = false;
                    this.alert_type = 'Error';
                    this.alert_message = error.response?.data?.message || 'Network error occurred';
                    this.$refs.alert_model.openModel();
                    reject();
                });
            });
        },

        getFieldOptions(field) {
            // Priority 1: Dynamic options from backend
            if (field.options && field.options.length > 0) {
                console.log(`Using dynamic options for ${field.column_id}:`, field.options);

                if (Array.isArray(field.options)) {
                    return field.options.map(opt => {
                        if (typeof opt === 'object' && opt !== null) {
                            return {
                                value: String(opt.value !== undefined ? opt.value : opt),
                                label: opt.label || opt.name || opt.text || String(opt.value || opt)
                            };
                        }
                        return {
                            value: String(opt),
                            label: String(opt)
                        };
                    });
                }
            }

            // Priority 2: Special handling for specific fields (including basic fields)
            switch (field.column_id) {
                case 'calling_status':
                    if (Array.isArray(this.status_list) && this.status_list.length > 0) {
                        return this.status_list.map(opt => ({
                            value: String(opt.value || opt.item_value || opt.id),
                            label: opt.label || opt.name || opt.text || 'Option'
                        }));
                    }
                    return [];

                case 'gender':
                case 'b_gender':
                    return [
                        { value: 'Male', label: 'Male' },
                        { value: 'Female', label: 'Female' }
                    ];

                case 'district_id':
                case 'b_district':
                    return this.district_list.map(district => ({
                        value: String(district.id),
                        label: district.name
                    }));

                case 'zone_id':
                case 'b_zone':
                    return this.zone_list.map(zone => ({
                        value: String(zone.id),
                        label: zone.name
                    }));

                case 'unit_id':
                case 'b_unit':
                    return this.unit_list.map(unit => ({
                        value: String(unit.id),
                        label: unit.name
                    }));

                case 'wing':
                case 'b_wing':
                    return [
                        { value: '1', label: 'ORG' },
                        { value: '2', label: 'Youth' },
                        { value: '3', label: 'Student' },
                        { value: '4', label: 'Womens' },
                        { value: '5', label: 'Balavedi' },
                        { value: '6', label: 'Girls' }
                    ];

                case 'pr_listener':
                case 'pr_finance':
                case 'mobile_changed':
                case 'registration_status':
                case 'self_confirmation_status':
                case 'will_come':
                case 'food_needed':
                case 'visited_status':
                case 'b_membership_status':
                    return [
                        { value: '1', label: 'Yes' },
                        { value: '0', label: 'No' }
                    ];

                default:
                    return [];
            }
        },

        // Helper methods for Basic Details display
        getGenderLabel(value) {
            if (!value) return '';
            const val = String(value).toLowerCase();
            if (val === 'male' || val === '1') return 'Male';
            if (val === 'female' || val === '2') return 'Female';
            return value;
        },

        getDistrictName(districtId) {
            if (!districtId) return '';
            const district = this.district_list.find(d => d.id == districtId);
            return district ? district.name : '';
        },

        getZoneName(zoneId) {
            if (!zoneId) return '';
            const zone = this.zone_list.find(z => z.id == zoneId);
            return zone ? zone.name : '';
        },

        getUnitName(unitId) {
            if (!unitId) return '';
            const unit = this.unit_list.find(u => u.id == unitId);
            return unit ? unit.name : '';
        },

        getEducationName(educationId) {
            if (!educationId) return '';
            
            // First, check if education name is already provided by backend
            const contact = this.searchResponse.contact;
            if (contact) {
                if (contact.b_education_name) {
                    return contact.b_education_name;
                }
                if (contact.education_name) {
                    return contact.education_name;
                }
            }
            
            // If it's already a name (not a number), return it
            if (isNaN(educationId)) {
                return educationId;
            }
            
            // Try to find in field options if available
            const educationField = this.fields.find(f => f.column_id === 'b_education' || f.column_id === 'education');
            if (educationField) {
                // Try field.options first
                if (educationField.options && educationField.options.length > 0) {
                    const education = educationField.options.find(e => {
                        const value = e.value !== undefined ? e.value : (e.id !== undefined ? e.id : null);
                        return value !== null && String(value) === String(educationId);
                    });
                    if (education) {
                        return education.label || education.name || education.text || '';
                    }
                }
                
                // Try getFieldOptions method
                const options = this.getFieldOptions(educationField);
                if (options && options.length > 0) {
                    const education = options.find(e => String(e.value) === String(educationId));
                    if (education) {
                        return education.label || education.name || '';
                    }
                }
            }
            
            // Check cache
            if (this.educationCache && this.educationCache[educationId]) {
                return this.educationCache[educationId];
            }
            
            // Return empty - will show ID as fallback
            return '';
        },

        getWingLabel(value) {
            if (!value) return '';
            const wingMap = {
                '1': 'ORG',
                '2': 'Youth',
                '3': 'Student',
                '4': 'Womens',
                '5': 'Balavedi',
                '6': 'Girls'
            };
            return wingMap[String(value)] || value;
        },
        
        // Helper method for Basic Fields - gets value from formData or contact (basic fields are now columns)
        getBasicFieldValue(columnId) {
            const formValue = this.formData[columnId];
            const contactValue = this.searchResponse.contact?.[columnId];
            
            // Basic fields are now stored in separate columns, not in custom_fields
            return formValue || contactValue;
        },

        // Check if a basic field is enabled in campaign configuration
        isBasicFieldEnabled(columnId) {
            // If basicFields configuration hasn't loaded yet, show all fields by default
            if (!this.basicFields || this.basicFields.length === 0) {
                return true;
            }
            // Once configuration is loaded, only show explicitly enabled fields
            const field = this.basicFields.find(f => f.column_id === columnId);
            // If field is found in config, return its enabled status
            // If field is not in config, hide it (false)
            return field ? field.enabled : false;
        },

        // Check if the contact is a member
        isMember() {
            const isMember = this.searchResponse.contact?.is_member;
            return isMember === 1 || isMember === true || isMember === '1' || isMember === 'Y';
        },

        setDetailTab(tab) {
            this.activeDetailTab = tab;
        },

        // Computed-like helper for call history list
        callHistoryList() {
            const contact = this.searchResponse && this.searchResponse.contact;
            if (!contact) return [];
            // Support multiple possible backend shapes
            if (Array.isArray(contact.call_history)) return contact.call_history;
            if (Array.isArray(contact.history)) return contact.history;
            return [];
        },

        formatCallHistoryMain(item) {
            // Try to build a main line similar to "Yesterday, 10:30 AM"
            if (!item) return '';

            // If backend already provides a formatted label/text, prefer that
            if (item.title) return item.title;
            if (item.label) return item.label;
            if (item.text) return item.text;

            const parts = [];
            if (item.date_label) parts.push(item.date_label);
            else if (item.date) parts.push(item.date);

            if (item.time) parts.push(item.time);

            return parts.join(', ');
        },

        formatCallHistoryMeta(item) {
            if (!item) return '';

            // Typical meta: "15 min", "No answer", etc.
            if (item.meta) return item.meta;
            if (item.duration && item.outcome) {
                return `${item.duration} · ${item.outcome}`;
            }
            if (item.duration) return item.duration;
            if (item.outcome) return item.outcome;

            return '';
        },

        openSuggestEditDialog() {
            this.dialog_message = 'Suggest edits to contact data (subject to admin approval).';
            this.dialog_action = '';
            this.dialog_action_params = null;
            this.$refs.dialog_model.openModel();
        },

        search(mobile = null) {
            try {
                if (mobile) {
                    this.search_qry = mobile;
                }
                if (!this.search_qry) {
                    this.alert_type = 'Warning';
                    this.alert_message = 'Please enter a mobile number to search';
                    this.$refs.alert_model.openModel();
                    return;
                }

                this.search_loading = true;
                this.hideContactAlternatives();

                let data = {
                    q: this.search_qry,
                    id: this.$route.params.id,
                }

                UserService.authPostRequest('v2/get-call-campign-contact', data).then(
                    (response) => {
                        if (response.data.status == 'success') {
                            this.search_loading = false;
                            this.searchResponse = response.data.data;

                            if (this.searchResponse.contact) {
                                console.log('Contact loaded:', this.searchResponse.contact);
                                console.log('Education ID:', this.searchResponse.contact.b_education || this.searchResponse.contact.education);
                                console.log('Education Name:', this.searchResponse.contact.b_education_name || this.searchResponse.contact.education_name);
                                console.log('Custom fields in contact:', this.searchResponse.contact.custom_fields);

                                // Set basic fields
                                this.formData.id = this.searchResponse.contact.id || this.searchResponse.contact.contact_id;
                                this.formData.wisdom_member = this.searchResponse.contact.wisdom_member;
                                this.formData.name = this.searchResponse.contact.name;
                                this.formData.mobile = this.searchResponse.contact.mobile;
                                this.formData.comments = this.searchResponse.contact.comments;

                                // Call populate method which handles custom_fields
                                this.populateFormFromContact(this.searchResponse.contact);
                                this.$root.updateParent('Call Campaign');
                            }
                        } else {
                            this.search_loading = false;
                            if (response.data.data && response.data.data.valid_contacts) {
                                this.showContactAlternativesFromResponse(response.data.data.valid_contacts, response.data.message);
                            } else {
                                this.alert_type = 'Error';
                                this.alert_message = response.data.message || 'Contact not found';
                                this.$refs.alert_model.openModel();
                                this.fetchValidContacts();
                            }
                        }
                    },
                    (error) => {
                        this.search_loading = false;
                        this.alert_type = 'Error';
                        this.alert_message = error.response?.data?.message || 'Network error occurred';
                        this.$refs.alert_model.openModel();
                        this.fetchValidContacts();
                    }
                );
            } catch (error) {
                this.search_loading = false;
                this.alert_type = 'Error';
                this.alert_message = 'An unexpected error occurred';
                this.$refs.alert_model.openModel();
            }
        },

        populateFormFromContact(contactData) {
            this.form_data_loading = true;

            console.log('Populating form with contact:', contactData);
            console.log('Custom fields:', contactData.custom_fields);

            // Clear existing data
            this.fields.forEach(field => {
                if (field.type === 'Checkbox') {
                    this.formData[field.column_id] = [];
                } else {
                    this.formData[field.column_id] = '';
                }
            });

            // First, populate basic fields (now stored in separate columns)
            if (this.basicFields && this.basicFields.length > 0) {
                this.basicFields.forEach(field => {
                    const columnId = field.column_id;
                    let value = contactData[columnId];
                    
                    // Basic fields are now stored in separate columns, not in custom_fields
                    
                    if (value !== undefined && value !== null && value !== '') {
                        if (field.type === 'Select') {
                            this.formData[columnId] = String(value);
                        } else if (field.type === 'Radio') {
                            if (value === true || value === 1 || value === '1' || value === 'Y') {
                                this.formData[columnId] = '1';
                            } else if (value === false || value === 0 || value === '0' || value === 'N') {
                                this.formData[columnId] = '0';
                            } else {
                                this.formData[columnId] = String(value);
                            }
                        } else if (field.type === 'Checkbox') {
                            // Handle checkbox values - convert to clean array
                            if (Array.isArray(value)) {
                                const allValues = [];
                                value.forEach(v => {
                                    const cleaned = typeof v === 'string' ? v.replace(/[\\'"[\]]/g, '').trim() : String(v).trim();
                                    if (cleaned.includes(',')) {
                                        cleaned.split(',').forEach(item => {
                                            if (item.trim()) allValues.push(item.trim());
                                        });
                                    } else if (cleaned) {
                                        allValues.push(cleaned);
                                    }
                                });
                                this.formData[columnId] = [...new Set(allValues)];
                            } else if (typeof value === 'string') {
                                try {
                                    let parsed = JSON.parse(value);
                                    while (typeof parsed === 'string' && (parsed.startsWith('[') || parsed.startsWith('"'))) {
                                        try {
                                            parsed = JSON.parse(parsed);
                                        } catch (e) {
                                            break;
                                        }
                                    }
                                    if (Array.isArray(parsed)) {
                                        const allValues = [];
                                        parsed.forEach(v => {
                                            const cleaned = typeof v === 'string' ? v.replace(/[\\'"[\]]/g, '').trim() : String(v).trim();
                                            if (cleaned.includes(',')) {
                                                cleaned.split(',').forEach(item => {
                                                    if (item.trim()) allValues.push(item.trim());
                                                });
                                            } else if (cleaned) {
                                                allValues.push(cleaned);
                                            }
                                        });
                                        this.formData[columnId] = [...new Set(allValues)];
                                    } else {
                                        const cleaned = typeof parsed === 'string' ? parsed.replace(/[\\'"[\]]/g, '').trim() : String(parsed).trim();
                                        this.formData[columnId] = cleaned ? [cleaned] : [];
                                    }
                                } catch (e) {
                                    const cleaned = value.replace(/[\\'"[\]]/g, '').trim();
                                    this.formData[columnId] = cleaned.includes(',') 
                                        ? cleaned.split(',').map(v => v.trim()).filter(v => v)
                                        : [cleaned].filter(v => v);
                                }
                            } else {
                                this.formData[columnId] = [String(value)];
                            }
                        } else {
                            this.formData[columnId] = String(value);
                        }
                    }
                });
            }
            
            // Then, populate standard fields
            this.fields.forEach(field => {
                const columnId = field.column_id;
                let value = contactData[columnId];

                if (value !== undefined && value !== null && value !== '') {
                    if (field.type === 'Select') {
                        this.formData[columnId] = String(value);
                    } else if (field.type === 'Radio') {
                        if (value === true || value === 1 || value === '1' || value === 'Y') {
                            this.formData[columnId] = '1';
                        } else if (value === false || value === 0 || value === '0' || value === 'N') {
                            this.formData[columnId] = '0';
                        } else {
                            this.formData[columnId] = String(value);
                        }
                    } else if (field.type === 'Checkbox') {
                        // Handle checkbox values - convert to clean array
                        if (Array.isArray(value)) {
                            // Already an array, just clean it
                            const allValues = [];
                            value.forEach(v => {
                                const cleaned = typeof v === 'string' ? v.replace(/[\\'"[\]]/g, '').trim() : String(v).trim();
                                if (cleaned.includes(',')) {
                                    cleaned.split(',').forEach(item => {
                                        if (item.trim()) allValues.push(item.trim());
                                    });
                                } else if (cleaned) {
                                    allValues.push(cleaned);
                                }
                            });
                            this.formData[columnId] = [...new Set(allValues)];
                        } else if (typeof value === 'string') {
                            // Try to parse as JSON array
                            try {
                                let parsed = JSON.parse(value);
                                // Keep parsing if still a string
                                while (typeof parsed === 'string' && (parsed.startsWith('[') || parsed.startsWith('"'))) {
                                    try {
                                        parsed = JSON.parse(parsed);
                                    } catch (e) {
                                        break;
                                    }
                                }
                                // Now clean the parsed value
                                if (Array.isArray(parsed)) {
                                    const allValues = [];
                                    parsed.forEach(v => {
                                        const cleaned = typeof v === 'string' ? v.replace(/[\\'"[\]]/g, '').trim() : String(v).trim();
                                        if (cleaned.includes(',')) {
                                            cleaned.split(',').forEach(item => {
                                                if (item.trim()) allValues.push(item.trim());
                                            });
                                        } else if (cleaned) {
                                            allValues.push(cleaned);
                                        }
                                    });
                                    this.formData[columnId] = [...new Set(allValues)];
                                } else {
                                    const cleaned = typeof parsed === 'string' ? parsed.replace(/[\\'"[\]]/g, '').trim() : String(parsed).trim();
                                    this.formData[columnId] = cleaned ? [cleaned] : [];
                                }
                            } catch (e) {
                                // Not JSON, split by comma
                                const cleaned = value.replace(/[\\'"[\]]/g, '').trim();
                                this.formData[columnId] = cleaned.includes(',') 
                                    ? cleaned.split(',').map(v => v.trim()).filter(v => v)
                                    : [cleaned].filter(v => v);
                            }
                        } else {
                            this.formData[columnId] = [String(value)];
                        }
                        console.log(`Loaded ${columnId} from standard field:`, this.formData[columnId]);
                    } else {
                        this.formData[columnId] = String(value);
                    }
                }
            });

            // CRITICAL: Handle custom_fields - this is where test_field data is stored
            if (contactData.custom_fields) {
                let customFields = contactData.custom_fields;

                // Parse if it's a string
                if (typeof customFields === 'string') {
                    try {
                        customFields = JSON.parse(customFields);
                        console.log('Parsed custom fields:', customFields);
                    } catch (e) {
                        console.error('Failed to parse custom_fields:', e);
                        customFields = {};
                    }
                }

                // Now populate each custom field
                if (customFields && typeof customFields === 'object') {
                    // Loop through all fields to find custom ones
                    this.fields.forEach(field => {
                        // Check if this field has a value in custom_fields
                        if (customFields[field.column_id] !== undefined) {
                            console.log(`Setting custom field ${field.column_id}:`, customFields[field.column_id]);
                            let value = customFields[field.column_id];
                            
                            // Handle checkbox fields - ensure they're arrays
                            if (field.type === 'Checkbox') {
                                // Recursive function to deeply parse nested JSON
                                const deepParse = (val) => {
                                    if (typeof val === 'string') {
                                        // Keep parsing until we can't anymore
                                        let parsed = val;
                                        let maxAttempts = 10; // Prevent infinite loops
                                        while (maxAttempts > 0 && typeof parsed === 'string' && (parsed.startsWith('[') || parsed.startsWith('"') || parsed.includes('\\'))) {
                                            try {
                                                const newParsed = JSON.parse(parsed);
                                                if (newParsed === parsed) break; // Stop if no change
                                                parsed = newParsed;
                                                maxAttempts--;
                                            } catch (e) {
                                                break;
                                            }
                                        }
                                        return parsed;
                                    }
                                    return val;
                                };
                                
                                // Flatten nested arrays recursively
                                const flattenArray = (arr) => {
                                    if (!Array.isArray(arr)) return [arr];
                                    return arr.reduce((acc, item) => {
                                        if (Array.isArray(item)) {
                                            return acc.concat(flattenArray(item));
                                        }
                                        const parsed = deepParse(item);
                                        if (Array.isArray(parsed)) {
                                            return acc.concat(flattenArray(parsed));
                                        }
                                        return acc.concat(parsed);
                                    }, []);
                                };
                                
                                // Clean the values after parsing
                                const cleanValue = (val) => {
                                    if (typeof val === 'string') {
                                        let cleaned = val;
                                        while (/[\\'"[\]]/.test(cleaned)) {
                                            cleaned = cleaned.replace(/[\\'"[\]]/g, '');
                                        }
                                        return cleaned.trim();
                                    }
                                    return val ? String(val).trim() : '';
                                };
                                
                                if (Array.isArray(value)) {
                                    const flattened = flattenArray(value);
                                    // Split comma-separated values and clean
                                    const allValues = [];
                                    flattened.forEach(v => {
                                        const cleaned = cleanValue(v);
                                        if (cleaned.includes(',')) {
                                            cleaned.split(',').forEach(item => {
                                                const trimmed = item.trim();
                                                if (trimmed) allValues.push(trimmed);
                                            });
                                        } else if (cleaned) {
                                            allValues.push(cleaned);
                                        }
                                    });
                                    this.formData[field.column_id] = [...new Set(allValues)].filter(v => v && v !== '');
                                } else if (typeof value === 'string') {
                                    const parsed = deepParse(value);
                                    if (Array.isArray(parsed)) {
                                        const flattened = flattenArray(parsed);
                                        const allValues = [];
                                        flattened.forEach(v => {
                                            const cleaned = cleanValue(v);
                                            if (cleaned.includes(',')) {
                                                cleaned.split(',').forEach(item => {
                                                    const trimmed = item.trim();
                                                    if (trimmed) allValues.push(trimmed);
                                                });
                                            } else if (cleaned) {
                                                allValues.push(cleaned);
                                            }
                                        });
                                        this.formData[field.column_id] = [...new Set(allValues)].filter(v => v && v !== '');
                                    } else {
                                        const cleaned = cleanValue(parsed);
                                        this.formData[field.column_id] = cleaned ? [cleaned] : [];
                                    }
                                } else {
                                    this.formData[field.column_id] = value ? [String(value)] : [];
                                }
                                console.log(`Final checkbox value for ${field.column_id}:`, this.formData[field.column_id]);
                            } else {
                                this.formData[field.column_id] = value;
                            }
                        }
                    });

                    // Specifically handle test_field if it exists
                    if (customFields.test_field !== undefined) {
                        console.log('Setting test_field:', customFields.test_field);
                        this.formData.test_field = customFields.test_field;
                    }
                }
            }

            // Handle other standard fields...
            ['name', 'mobile', 'place', 'comments'].forEach(fieldName => {
                if (contactData[fieldName] !== undefined && contactData[fieldName] !== null) {
                    this.formData[fieldName] = contactData[fieldName];
                }
            });

            // Handle cascading dropdowns...
            if (contactData.district_id) {
                this.formData.district_id = String(contactData.district_id);
                this.fetchZones(contactData.district_id);

                setTimeout(() => {
                    if (contactData.zone_id) {
                        this.formData.zone_id = String(contactData.zone_id);
                        this.fetchUnits(contactData.zone_id);

                        setTimeout(() => {
                            if (contactData.unit_id) {
                                this.formData.unit_id = String(contactData.unit_id);
                            }
                        }, 500);
                    }
                }, 500);
            }

            this.$nextTick(() => {
                // Force update all custom fields one more time
                if (contactData.custom_fields) {
                    let customFields = contactData.custom_fields;
                    if (typeof customFields === 'string') {
                        try {
                            customFields = JSON.parse(customFields);
                        } catch (e) {
                            customFields = {};
                        }
                    }

                    Object.keys(customFields).forEach(key => {
                        // Skip basic fields (b_*) as they are now stored in separate columns
                        if (key.startsWith('b_')) {
                            return;
                        }
                        
                        const field = this.fields.find(f => f.column_id === key);
                        let value = customFields[key];
                        
                        // Handle checkbox fields specially
                        if (field && field.type === 'Checkbox') {
                            // Use the same deep parsing logic
                            const deepParse = (val) => {
                                if (typeof val === 'string') {
                                    let parsed = val;
                                    let maxAttempts = 10;
                                    while (maxAttempts > 0 && typeof parsed === 'string' && (parsed.startsWith('[') || parsed.startsWith('"') || parsed.includes('\\'))) {
                                        try {
                                            const newParsed = JSON.parse(parsed);
                                            if (newParsed === parsed) break;
                                            parsed = newParsed;
                                            maxAttempts--;
                                        } catch (e) {
                                            break;
                                        }
                                    }
                                    return parsed;
                                }
                                return val;
                            };
                            
                            const flattenArray = (arr) => {
                                if (!Array.isArray(arr)) return [arr];
                                return arr.reduce((acc, item) => {
                                    if (Array.isArray(item)) {
                                        return acc.concat(flattenArray(item));
                                    }
                                    const parsed = deepParse(item);
                                    if (Array.isArray(parsed)) {
                                        return acc.concat(flattenArray(parsed));
                                    }
                                    return acc.concat(parsed);
                                }, []);
                            };
                            
                            const cleanValue = (val) => {
                                if (typeof val === 'string') {
                                    let cleaned = val;
                                    while (/[\\'"[\]]/.test(cleaned)) {
                                        cleaned = cleaned.replace(/[\\'"[\]]/g, '');
                                    }
                                    return cleaned.trim();
                                }
                                return val ? String(val).trim() : '';
                            };
                            
                            if (Array.isArray(value)) {
                                const flattened = flattenArray(value);
                                const allValues = [];
                                flattened.forEach(v => {
                                    const cleaned = cleanValue(v);
                                    if (cleaned.includes(',')) {
                                        cleaned.split(',').forEach(item => {
                                            const trimmed = item.trim();
                                            if (trimmed) allValues.push(trimmed);
                                        });
                                    } else if (cleaned) {
                                        allValues.push(cleaned);
                                    }
                                });
                                value = [...new Set(allValues)].filter(v => v && v !== '');
                            } else if (typeof value === 'string') {
                                const parsed = deepParse(value);
                                if (Array.isArray(parsed)) {
                                    const flattened = flattenArray(parsed);
                                    const allValues = [];
                                    flattened.forEach(v => {
                                        const cleaned = cleanValue(v);
                                        if (cleaned.includes(',')) {
                                            cleaned.split(',').forEach(item => {
                                                const trimmed = item.trim();
                                                if (trimmed) allValues.push(trimmed);
                                            });
                                        } else if (cleaned) {
                                            allValues.push(cleaned);
                                        }
                                    });
                                    value = [...new Set(allValues)].filter(v => v && v !== '');
                                } else {
                                    const cleaned = cleanValue(parsed);
                                    value = cleaned ? [cleaned] : [];
                                }
                            } else {
                                value = value ? [String(value)] : [];
                            }
                        }
                        
                        if (JSON.stringify(this.formData[key]) !== JSON.stringify(value)) {
                            this.formData[key] = value;
                        }
                    });
                }

                this.syncFormDataToVeeValidate();
                this.form_data_loading = false;
                this.$forceUpdate();
            });
        },

        handleRegistration(data) {
            console.log('handleRegistration called with data:', data);
            console.log('Form data:', this.formData);
            
            // Manual validation for required fields
            const requiredFields = this.enabledFields.filter(field => field.required);
            const missingFields = [];
            
            for (const field of requiredFields) {
                const value = this.formData[field.column_id];
                // Allow 0 and "0" as valid values
                if (value !== 0 && value !== '0' && !value) {
                    missingFields.push(field.label || field.column_id);
                }
            }
            
            if (missingFields.length > 0) {
                this.alert_type = 'Error';
                this.alert_message = `Please fill required fields: ${missingFields.join(', ')}`;
                this.$refs.alert_model.openModel();
                return;
            }
            
            const contact = this.searchResponse.contact;
            const contactId = contact && (contact.id || contact.contact_id);

            if (!contact || !contactId) {
                console.error('No valid contact found:', contact);
                this.alert_type = 'Error';
                this.alert_message = 'No valid contact found. Please wait for contact data to load or refresh the page.';
                this.$refs.alert_model.openModel();
                return;
            }

            console.log('Form validation passed, proceeding with submission');
            this.btn_loading = true;

            const formattedData = { ...data };

            // Handle phone numbers with country code
            const mobileFields = ['mobile2', 'whatsapp', 'mobile_new'];
            mobileFields.forEach(fieldId => {
                if (formattedData[fieldId] && formattedData[fieldId].toString().length > 0) {
                    const parts = this.buildPhonePartsForSubmit(fieldId, formattedData[fieldId]);
                    formattedData[fieldId] = parts.local;
                    formattedData[fieldId + '_country_code'] = parts.code;
                }
            });

            // Add all basic fields to formattedData (they will be stored in custom_fields if not fillable)
            if (this.basicFields && this.basicFields.length > 0) {
                this.basicFields.forEach(field => {
                    const fieldId = field.column_id;
                    if (this.formData[fieldId] !== undefined && this.formData[fieldId] !== null) {
                        let value = this.formData[fieldId];
                        
                        // Clean checkbox values to prevent nested JSON
                        if (field.type === 'Checkbox') {
                            if (Array.isArray(value)) {
                                const allValues = [];
                                value.forEach(v => {
                                    if (typeof v === 'string') {
                                        let cleaned = v;
                                        while (/[\\'"[\]]/.test(cleaned)) {
                                            cleaned = cleaned.replace(/[\\'"[\]]/g, '');
                                        }
                                        if (cleaned.includes(',')) {
                                            cleaned.split(',').forEach(item => {
                                                const trimmed = item.trim();
                                                if (trimmed) allValues.push(trimmed);
                                            });
                                        } else if (cleaned.trim()) {
                                            allValues.push(cleaned.trim());
                                        }
                                    } else if (v) {
                                        allValues.push(String(v).trim());
                                    }
                                });
                                value = [...new Set(allValues)].filter(v => v && v !== '');
                            } else if (value) {
                                let cleaned = String(value);
                                while (/[\\'"[\]]/.test(cleaned)) {
                                    cleaned = cleaned.replace(/[\\'"[\]]/g, '');
                                }
                                value = [cleaned.trim()].filter(v => v);
                            } else {
                                value = [];
                            }
                        }
                        
                        // Basic fields with b_ prefix should be sent in the request
                        formattedData[fieldId] = value;
                    }
                });
            }
            
            // Add all form fields to formattedData, cleaning checkbox values
            this.fields.forEach(field => {
                const fieldId = field.column_id;
                if (this.formData[fieldId] !== undefined && this.formData[fieldId] !== null) {
                    let value = this.formData[fieldId];
                    
                    // Clean checkbox values to prevent nested JSON
                    if (field.type === 'Checkbox') {
                        if (Array.isArray(value)) {
                            // Flatten and split comma-separated strings
                            const allValues = [];
                            value.forEach(v => {
                                if (typeof v === 'string') {
                                    // Remove ALL escape characters, quotes, and brackets
                                    let cleaned = v;
                                    while (/[\\'"[\]]/.test(cleaned)) {
                                        cleaned = cleaned.replace(/[\\'"[\]]/g, '');
                                    }
                                    // Split by comma in case multiple values are in one string
                                    if (cleaned.includes(',')) {
                                        cleaned.split(',').forEach(item => {
                                            const trimmed = item.trim();
                                            if (trimmed) allValues.push(trimmed);
                                        });
                                    } else if (cleaned.trim()) {
                                        allValues.push(cleaned.trim());
                                    }
                                } else if (v) {
                                    allValues.push(String(v).trim());
                                }
                            });
                            // Remove duplicates and empty values
                            value = [...new Set(allValues)].filter(v => v && v !== '');
                        } else if (value) {
                            let cleaned = String(value);
                            while (/[\\'"[\]]/.test(cleaned)) {
                                cleaned = cleaned.replace(/[\\'"[\]]/g, '');
                            }
                            value = [cleaned.trim()].filter(v => v);
                        } else {
                            value = [];
                        }
                        console.log(`Cleaned ${fieldId} for submission:`, value);
                    }
                    
                    formattedData[fieldId] = value;
                }
            });

            // Collect all custom field values (any field not in system fields)
            // Note: Basic fields (b_*) are now stored in separate columns, NOT in custom_fields
            const systemFields = [
                'id', 'contact_id', 'campaign_id', '_token', 'questians_responses',
                'name', 'mobile', 'comments', 'status', 'calling_status',
                'district_id', 'zone_id', 'unit_id', 'wing', 'gender',
                'mobile2', 'whatsapp', 'mobile_new', 'mobile2_country_code', 'whatsapp_country_code', 'country_code',
                'assigned_mobile', 'assigned_user_id', 'background_summery', 'created_at', 'deleted_at', 'designation',
                'food_needed', 'is_member', 'job', 'member_id', 'mentor_id', 'place', 'registration_status', 'self_confirmation_status', 'will_come', 'will_arrive_at', 'transportation',
                // Basic fields are now separate columns, not custom fields
                'b_name', 'b_gender', 'b_age', 'b_mobile', 'b_whatsapp', 'b_place', 'b_district', 'b_zone', 'b_unit', 'b_wing', 'b_membership_status', 'b_member_id', 'b_job', 'b_education', 'b_institution', 'b_background', 'b_org_positions', 'b_org_departments'
            ];
            const customFields = {};
            
            // Add only non-system, non-basic custom fields
            this.fields.forEach(field => {
                if (!systemFields.includes(field.column_id) && !field.column_id.startsWith('b_')) {
                    let value = this.formData[field.column_id];
                    // Clean checkbox values before saving - ensure they're simple arrays
                    if (field.type === 'Checkbox') {
                        if (Array.isArray(value)) {
                            // Flatten and split comma-separated strings
                            const allValues = [];
                            value.forEach(v => {
                                if (typeof v === 'string') {
                                    let cleaned = v;
                                    while (/[\\'"[\]]/.test(cleaned)) {
                                        cleaned = cleaned.replace(/[\\'"[\]]/g, '');
                                    }
                                    if (cleaned.includes(',')) {
                                        cleaned.split(',').forEach(item => {
                                            const trimmed = item.trim();
                                            if (trimmed) allValues.push(trimmed);
                                        });
                                    } else if (cleaned.trim()) {
                                        allValues.push(cleaned.trim());
                                    }
                                } else if (v) {
                                    allValues.push(String(v).trim());
                                }
                            });
                            value = [...new Set(allValues)].filter(v => v && v !== '');
                        } else if (value) {
                            let cleaned = String(value);
                            while (/[\\'"[\]]/.test(cleaned)) {
                                cleaned = cleaned.replace(/[\\'"[\]]/g, '');
                            }
                            value = [cleaned.trim()].filter(v => v);
                        } else {
                            value = [];
                        }
                    }
                    customFields[field.column_id] = value;
                }
            });
            formattedData.custom_fields = customFields;

            // IMPORTANT: Send values as-is, NOT converting to labels
            formattedData.id = contactId;
            formattedData.contact_id = contactId;
            formattedData.campaign_id = contact.campaign_id || this.$route.params.id;
            formattedData.questians_responses = this.questians_responses;

            console.log('Submitting form data:', formattedData);

            UserService.authPostRequest("v2/store-campign-response", formattedData).then(
                (response) => {
                    if (response.data.status == "success") {
                        this.alertRedirectRoute = "/call-follow-up-v2/" + this.$route.params.id;
                        this.pending_contacts = response.data.data.pending_contacts;
                        this.responseData.target = response.data.data.target;
                        this.responseData.balance = response.data.data.balance;
                        this.responseData.all_contacts = response.data.data.all_contacts;
                        this.alert_type = "Success";
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.searchResponse.contact = '';
                        this.search_qry = '';
                        this.btn_loading = false;
                    } else if (response.data.status == "warning") {
                        this.alertRedirectRoute = '';
                        this.alert_type = "Warning";
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.btn_loading = false;
                    } else {
                        this.alertRedirectRoute = '';
                        this.alert_type = "Error";
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.btn_loading = false;
                    }
                },
                (error) => {
                    this.btn_loading = false;
                    this.alertRedirectRoute = '';
                    this.alert_type = 'Error';
                    this.alert_message =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        'An error occurred while saving the form';
                    this.$refs.alert_model.openModel();
                }
            );
        },

        mapCallingStatus(value) {
            if (value === null || value === undefined || value === '') return '';

            const valueStr = String(value).trim();
            console.log('Mapping calling_status:', valueStr);

            if (!Array.isArray(this.status_list) || this.status_list.length === 0) {
                console.log('Status list not loaded yet');
                this.formData.calling_status_temp = valueStr;
                return '';
            }

            console.log('Available status options:', this.status_list);

            // Try exact match
            const foundByValue = this.status_list.find(opt => {
                return String(opt.value || '') === valueStr ||
                       String(opt.item_value || '') === valueStr ||
                       String(opt.id || '') === valueStr;
            });

            if (foundByValue) {
                const result = foundByValue.value || foundByValue.item_value || foundByValue.id;
                console.log('Found by value match:', result);
                return String(result);
            }

            // Try label match
            const lower = valueStr.toLowerCase();
            const foundByLabel = this.status_list.find(opt => {
                const optLabel = String(opt.label || '').toLowerCase();
                const optName = String(opt.name || '').toLowerCase();
                return optLabel === lower || optName === lower || optLabel.includes(lower);
            });

            if (foundByLabel) {
                const result = foundByLabel.value || foundByLabel.item_value || foundByLabel.id;
                console.log('Found by label match:', result);
                return String(result);
            }

            console.warn('No matching calling_status found for:', valueStr);
            this.formData.calling_status_temp = valueStr;
            return '';
        },

        mapBackendFieldType(backendType) {
            if (!backendType) return 'text';

            switch (backendType.toUpperCase()) {
                case 'RADIO': return 'Radio';
                case 'SELECT': return 'Select';
                case 'CHECKBOX': return 'Checkbox';
                case 'NUMBER': return 'Number';
                case 'TEXTAREA': return 'textarea';
                case 'DATETIME': return 'datetime-local';
                case 'TIME': return 'time';
                case 'TEXT': return 'text';
                default: return 'text';
            }
        },

        determineFieldType(columnId) {
            // Fallback method when backend doesn't specify field type
            switch (columnId) {
                case 'gender':
                case 'b_gender':
                case 'district_id':
                case 'b_district':
                case 'zone_id':
                case 'b_zone':
                case 'unit_id':
                case 'b_unit':
                case 'calling_status':
                case 'wing':
                case 'b_wing':
                    return 'Select';
                case 'pr_listener':
                case 'pr_finance':
                case 'mobile_changed':
                case 'registration_status':
                case 'self_confirmation_status':
                case 'will_come':
                case 'food_needed':
                case 'visited_status':
                case 'b_membership_status':
                    return 'Radio'; // Default fallback, but backend type takes precedence
                case 'mobile2':
                case 'whatsapp':
                case 'mobile_new':
                case 'b_mobile':
                case 'b_whatsapp':
                case 'b_age':
                    return 'Number';
                case 'pr_opinion':
                case 'pr_help_needed':
                case 'comments':
                case 'b_background':
                    return 'textarea';
                default:
                    return 'text';
            }
        },

        // Helper methods
        getComboboxValues(code, id = null) {
            return new Promise((resolve, reject) => {
                UserService.getCombobox({ code: code, type_id: id }).then(
                    (response) => {
                        switch (code) {
                            case "CALL_CAMPAIGN_STATUS":
                                this.status_list = response.data.data.list.options || [];
                                console.log('CALL_CAMPAIGN_STATUS loaded:', this.status_list);

                                if (this.formData.calling_status_temp) {
                                    const mapped = this.mapCallingStatus(this.formData.calling_status_temp);
                                    if (mapped) {
                                        this.formData.calling_status = mapped;
                                        this.$nextTick(() => {
                                            this.$forceUpdate();
                                        });
                                    }
                                }
                                break;
                            case "COUNTRY_CODE":
                                this.country_code_list = response.data.data.list.options || [];
                                break;
                        }
                        resolve();
                    },
                    () => {
                        this.loading = false;
                        reject();
                    }
                );
            });
        },

        fetchZones(districtId) {
            if (!districtId) {
                this.zone_list = [];
                this.unit_list = [];
                return;
            }

            const data = { district_id: districtId };
            const existingZoneId = this.formData.zone_id;

            UserService.authPostRequest('get-zone-by-id', data).then(
                (response) => {
                    if (response.data.status === 'success') {
                        this.zone_list = response.data.data.list || [];
                        if (existingZoneId && this.zone_list.find(zone => zone.id == existingZoneId)) {
                            this.formData.zone_id = existingZoneId;
                            this.fetchUnits(existingZoneId);
                        } else {
                            this.unit_list = [];
                            this.formData.zone_id = '';
                            this.formData.unit_id = '';
                        }
                    }
                },
                () => {
                    this.zone_list = [];
                    this.unit_list = [];
                }
            );
        },

        fetchUnits(zoneId) {
            if (!zoneId) {
                this.unit_list = [];
                return;
            }

            const data = { zone_id: zoneId };
            const existingUnitId = this.formData.unit_id;

            UserService.authPostRequest('get-unit-by-id', data).then(
                (response) => {
                    if (response.data.status === 'success') {
                        this.unit_list = response.data.data.list || [];
                        if (existingUnitId && this.unit_list.find(unit => unit.id == existingUnitId)) {
                            this.formData.unit_id = existingUnitId;
                        } else {
                            this.formData.unit_id = '';
                        }
                    }
                },
                () => {
                    this.unit_list = [];
                    this.formData.unit_id = '';
                }
            );
        },

        onDistrictChange(districtId) {
            this.fetchZones(districtId);
        },

        onZoneChange(zoneId) {
            this.fetchUnits(zoneId);
        },

        // Phone field helpers
        setPhoneFieldValues(fieldId, rawValue) {
            const parsed = this.parsePhoneNumber(rawValue);
            if (!parsed) return;
            if (parsed.localNumber !== null && parsed.localNumber !== undefined) {
                this.formData[fieldId] = parsed.localNumber;
            }
            if (parsed.countryCode) {
                this.formData[fieldId + '_country_code'] = parsed.countryCode;
            } else if (!this.formData[fieldId + '_country_code']) {
                this.formData[fieldId + '_country_code'] = '+91';
            }
        },

        parsePhoneNumber(phoneString) {
            try {
                if (!phoneString) return null;
                const digitsOnly = phoneString.toString().replace(/\D/g, '');
                if (digitsOnly.length <= 10) {
                    return { countryCode: null, localNumber: digitsOnly };
                }
                const localNumber = digitsOnly.slice(-10);
                const countryDigits = digitsOnly.slice(0, digitsOnly.length - 10);
                const countryCode = countryDigits ? ('+' + countryDigits) : null;
                return { countryCode, localNumber };
            } catch (e) {
                return null;
            }
        },

        buildPhonePartsForSubmit(fieldId, rawValue) {
            const selectedCodeRaw = this.formData[fieldId + '_country_code'] || '+91';
            const selectedCodeDigits = String(selectedCodeRaw).replace(/\D/g, '') || '91';
            let digits = (rawValue ?? '').toString().replace(/\D/g, '');
            if (selectedCodeDigits && digits.startsWith(selectedCodeDigits)) {
                digits = digits.slice(selectedCodeDigits.length);
            }
            if (digits.length > 10) digits = digits.slice(-10);
            return { local: digits, code: selectedCodeDigits };
        },

        mobileToWhatsapp(mobileNumber) {
            const cleanNumber = mobileNumber.replace(/\D/g, '');
            if (cleanNumber.length === 10) {
                return '91' + cleanNumber;
            } else {
                return cleanNumber;
            }
        },

        // Navigation helpers
        displayAll() {
            this.search_qry = '';
            this.searchResponse.contact = '';
            this.searchResponse.message = '';
        },

        gotoReport(mobile) {
            this.$router.push('/call-follow-up-V2/' + this.responseData.campign.reporting_campaign_id + '/' + mobile);
        },

        goToMentorManagement() {
            // Navigate to mentor management page with campaign_id
            const campaignId = this.responseData.campign.id;
            this.$router.push('/call-follow-up-v2/' + campaignId + '/assign-mentors');
        },

        gotoEdit(mobile) {
            const route = '/call-follow-up-edit-v2/' + this.$route.params.id + '/' + mobile;
            this.$router.push(route);
        },

        gotoEditWithData(memberData) {
            localStorage.setItem('editMemberData', JSON.stringify(memberData));
            const contactId = memberData.id;
            const route = '/call-follow-up-edit-v2/' + this.$route.params.id + '/' + contactId;
            this.$router.push(route);
        },

        loadStoredMemberData(memberData) {
            this.form_data_loading = true;
            this.searchResponse.contact = {
                contact_id: memberData.id,
                id: memberData.id,
                name: memberData.name || 'Stored Contact',
                mobile: memberData.assigned_mobile || memberData.mobile,
                campaign_id: this.$route.params.id,
                ...memberData
            };
            this.search_qry = memberData.assigned_mobile || memberData.mobile || memberData.id;

            if (this.fields.length === 0) {
                this.tempMemberData = memberData;
                return;
            }

            this.populateFormDirectly(memberData);
        },

        populateFormDirectly(memberData) {
            // Populate basic fields first (now stored in separate columns)
            if (this.basicFields && this.basicFields.length > 0) {
                this.basicFields.forEach(field => {
                    const columnId = field.column_id;
                    let value = memberData[columnId];
                    
                    // Basic fields are now stored in separate columns, not in custom_fields
                    
                    if (value !== undefined && value !== null && value !== '') {
                        if (field.type === 'Checkbox') {
                            if (Array.isArray(value)) {
                                const allValues = [];
                                value.forEach(v => {
                                    const cleaned = typeof v === 'string' ? v.replace(/[\\'"[\]]/g, '').trim() : String(v).trim();
                                    if (cleaned.includes(',')) {
                                        cleaned.split(',').forEach(item => {
                                            if (item.trim()) allValues.push(item.trim());
                                        });
                                    } else if (cleaned) {
                                        allValues.push(cleaned);
                                    }
                                });
                                this.formData[columnId] = [...new Set(allValues)];
                            } else if (typeof value === 'string') {
                                try {
                                    let parsed = JSON.parse(value);
                                    while (typeof parsed === 'string' && (parsed.startsWith('[') || parsed.startsWith('"'))) {
                                        try {
                                            parsed = JSON.parse(parsed);
                                        } catch (e) {
                                            break;
                                        }
                                    }
                                    if (Array.isArray(parsed)) {
                                        const allValues = [];
                                        parsed.forEach(v => {
                                            const cleaned = typeof v === 'string' ? v.replace(/[\\'"[\]]/g, '').trim() : String(v).trim();
                                            if (cleaned.includes(',')) {
                                                cleaned.split(',').forEach(item => {
                                                    if (item.trim()) allValues.push(item.trim());
                                                });
                                            } else if (cleaned) {
                                                allValues.push(cleaned);
                                            }
                                        });
                                        this.formData[columnId] = [...new Set(allValues)];
                                    } else {
                                        const cleaned = typeof parsed === 'string' ? parsed.replace(/[\\'"[\]]/g, '').trim() : String(parsed).trim();
                                        this.formData[columnId] = cleaned ? [cleaned] : [];
                                    }
                                } catch (e) {
                                    const cleaned = value.replace(/[\\'"[\]]/g, '').trim();
                                    this.formData[columnId] = cleaned.includes(',') 
                                        ? cleaned.split(',').map(v => v.trim()).filter(v => v)
                                        : [cleaned].filter(v => v);
                                }
                            } else {
                                this.formData[columnId] = [String(value)];
                            }
                        } else {
                            this.formData[columnId] = String(value);
                        }
                    }
                });
            }
            
            // Then populate regular fields
            this.fields.forEach(field => {
                const columnId = field.column_id;
                let value = memberData[columnId];
                
                if (value !== undefined && value !== null && value !== '') {
                    // Handle checkbox fields - keep them as arrays
                    if (field.type === 'Checkbox') {
                        if (Array.isArray(value)) {
                            // Already an array, just clean it
                            const allValues = [];
                            value.forEach(v => {
                                const cleaned = typeof v === 'string' ? v.replace(/[\\'"[\]]/g, '').trim() : String(v).trim();
                                if (cleaned.includes(',')) {
                                    cleaned.split(',').forEach(item => {
                                        if (item.trim()) allValues.push(item.trim());
                                    });
                                } else if (cleaned) {
                                    allValues.push(cleaned);
                                }
                            });
                            this.formData[columnId] = [...new Set(allValues)];
                        } else if (typeof value === 'string') {
                            // Try to parse as JSON array
                            try {
                                let parsed = JSON.parse(value);
                                // Keep parsing if still a string
                                while (typeof parsed === 'string' && (parsed.startsWith('[') || parsed.startsWith('"'))) {
                                    try {
                                        parsed = JSON.parse(parsed);
                                    } catch (e) {
                                        break;
                                    }
                                }
                                // Now clean the parsed value
                                if (Array.isArray(parsed)) {
                                    const allValues = [];
                                    parsed.forEach(v => {
                                        const cleaned = typeof v === 'string' ? v.replace(/[\\'"[\]]/g, '').trim() : String(v).trim();
                                        if (cleaned.includes(',')) {
                                            cleaned.split(',').forEach(item => {
                                                if (item.trim()) allValues.push(item.trim());
                                            });
                                        } else if (cleaned) {
                                            allValues.push(cleaned);
                                        }
                                    });
                                    this.formData[columnId] = [...new Set(allValues)];
                                } else {
                                    const cleaned = typeof parsed === 'string' ? parsed.replace(/[\\'"[\]]/g, '').trim() : String(parsed).trim();
                                    this.formData[columnId] = cleaned ? [cleaned] : [];
                                }
                            } catch (e) {
                                // Not JSON, split by comma
                                const cleaned = value.replace(/[\\'"[\]]/g, '').trim();
                                this.formData[columnId] = cleaned.includes(',') 
                                    ? cleaned.split(',').map(v => v.trim()).filter(v => v)
                                    : [cleaned].filter(v => v);
                            }
                        } else {
                            this.formData[columnId] = [String(value)];
                        }
                    } else {
                        // For non-checkbox fields, convert to string
                        this.formData[columnId] = String(value);
                    }
                }
            });
            // Populate custom fields
            if (memberData.custom_fields) {
                let customFields = memberData.custom_fields;
                
                // Parse if it's a string
                if (typeof customFields === 'string') {
                    try {
                        customFields = JSON.parse(customFields);
                    } catch (e) {
                        console.error('Failed to parse custom_fields:', e);
                        customFields = {};
                    }
                }
                
                if (customFields && typeof customFields === 'object') {
                    Object.keys(customFields).forEach(key => {
                        // Skip basic fields (b_*) as they are now stored in separate columns
                        if (key.startsWith('b_')) {
                            return;
                        }
                        
                        const field = this.fields.find(f => f.column_id === key);
                        let value = customFields[key];
                        
                        // Handle checkbox fields specially
                        if (field && field.type === 'Checkbox') {
                            if (Array.isArray(value)) {
                                const allValues = [];
                                value.forEach(v => {
                                    const cleaned = typeof v === 'string' ? v.replace(/[\\'"[\]]/g, '').trim() : String(v).trim();
                                    if (cleaned.includes(',')) {
                                        cleaned.split(',').forEach(item => {
                                            if (item.trim()) allValues.push(item.trim());
                                        });
                                    } else if (cleaned) {
                                        allValues.push(cleaned);
                                    }
                                });
                                this.formData[key] = [...new Set(allValues)];
                            } else if (typeof value === 'string') {
                                try {
                                    let parsed = JSON.parse(value);
                                    while (typeof parsed === 'string' && (parsed.startsWith('[') || parsed.startsWith('"'))) {
                                        try {
                                            parsed = JSON.parse(parsed);
                                        } catch (e) {
                                            break;
                                        }
                                    }
                                    if (Array.isArray(parsed)) {
                                        const allValues = [];
                                        parsed.forEach(v => {
                                            const cleaned = typeof v === 'string' ? v.replace(/[\\'"[\]]/g, '').trim() : String(v).trim();
                                            if (cleaned.includes(',')) {
                                                cleaned.split(',').forEach(item => {
                                                    if (item.trim()) allValues.push(item.trim());
                                                });
                                            } else if (cleaned) {
                                                allValues.push(cleaned);
                                            }
                                        });
                                        this.formData[key] = [...new Set(allValues)];
                                    } else {
                                        const cleaned = typeof parsed === 'string' ? parsed.replace(/[\\'"[\]]/g, '').trim() : String(parsed).trim();
                                        this.formData[key] = cleaned ? [cleaned] : [];
                                    }
                                } catch (e) {
                                    const cleaned = value.replace(/[\\'"[\]]/g, '').trim();
                                    this.formData[key] = cleaned.includes(',') 
                                        ? cleaned.split(',').map(v => v.trim()).filter(v => v)
                                        : [cleaned].filter(v => v);
                                }
                            } else {
                                this.formData[key] = value ? [String(value)] : [];
                            }
                        } else {
                            this.formData[key] = value;
                        }
                    });
                }
            }
            // Handle cascading dropdowns for both basic and regular fields
            const districtId = memberData.b_district || memberData.district_id;
            const zoneId = memberData.b_zone || memberData.zone_id;
            const unitId = memberData.b_unit || memberData.unit_id;
            
            if (districtId) {
                this.formData.b_district = memberData.b_district || '';
                this.formData.district_id = memberData.district_id || '';
                this.fetchZones(districtId);
            }

            if (zoneId) {
                setTimeout(() => {
                    this.formData.b_zone = memberData.b_zone || '';
                    this.formData.zone_id = memberData.zone_id || '';
                    if (unitId) {
                        this.fetchUnits(zoneId);
                        setTimeout(() => {
                            this.formData.b_unit = memberData.b_unit || '';
                            this.formData.unit_id = memberData.unit_id || '';
                        }, 500);
                    }
                }, 500);
            }

            this.$nextTick(() => {
                this.syncFormDataToVeeValidate();
                this.form_data_loading = false;
            });
        },

        syncFormDataToVeeValidate() {
            this.fields.forEach(field => {
                const columnId = field.column_id;
                let value = this.formData[columnId];
                // For SELECT fields, ensure we send the actual option value, not boolean
                if (field.type === 'Select' && Array.isArray(field.options)) {
                    // If value is boolean, map to option value
                    if (typeof value === 'boolean') {
                        const opt = field.options.find(opt => opt.value === 'Yes' && value === true || opt.value === 'No' && value === false || opt.value === '1' && value === true || opt.value === '0' && value === false);
                        if (opt) value = opt.value;
                    }
                    this.formData[columnId] = value;
                } else {
                    this.formData[columnId] = value;
                }
            });
            this.$forceUpdate();
        },

        searchWithValidation(contactId) {
            this.search(contactId);
        },

        showContactAlternativesFromResponse(validContacts, message) {
            this.validContactsList = validContacts.slice(0, 10);
            this.showContactAlternativesList = true;

            let alternativeMessage = message || `Contact ID ${this.search_qry} not found.`;
            alternativeMessage += `\n\nAvailable contacts are shown below. Click on any contact to select it.`;

            this.alert_type = 'Warning';
            this.alert_message = alternativeMessage;
            this.$refs.alert_model.openModel();
        },

        fetchValidContacts() {
            const data = { campaign_id: this.$route.params.id };

            UserService.authPostRequest('v2/get-valid-contacts', data).then(
                (response) => {
                    if (response.data.status === 'success' && response.data.data.contacts) {
                        this.validContactsList = response.data.data.contacts.slice(0, 10);
                        this.showContactAlternativesList = true;
                    }
                },
                (error) => {
                    console.log('Failed to fetch valid contacts:', error);
                }
            );
        },

        selectValidContact(contact) {
            this.hideContactAlternatives();
            this.search_qry = contact.id;
            this.search(contact.id);
        },

        hideContactAlternatives() {
            this.showContactAlternativesList = false;
            this.validContactsList = [];
        },

        // Checkbox helper methods
        isCheckboxChecked(fieldId, optionValue) {
            const fieldValue = this.formData[fieldId];
            console.log(`Checking ${fieldId} for ${optionValue}:`, fieldValue);

            // If field value is an array, check if option is in array
            if (Array.isArray(fieldValue)) {
                // Normalize and split comma-separated values
                const allNormalizedValues = [];
                fieldValue.forEach(val => {
                    if (typeof val === 'string') {
                        // Remove all backslashes, quotes, and brackets
                        let cleaned = val.replace(/[\\'"[\]]/g, '').trim();
                        // Split by comma if it contains commas
                        if (cleaned.includes(',')) {
                            cleaned.split(',').forEach(item => {
                                const trimmed = item.trim();
                                if (trimmed) allNormalizedValues.push(trimmed);
                            });
                        } else if (cleaned) {
                            allNormalizedValues.push(cleaned);
                        }
                    } else if (val) {
                        allNormalizedValues.push(String(val));
                    }
                });
                
                // Also normalize the option value we're checking for
                const normalizedOption = optionValue.replace(/[\\'"[\]]/g, '').trim();
                
                const isChecked = allNormalizedValues.includes(normalizedOption);
                console.log(`Normalized values:`, allNormalizedValues);
                console.log(`Checking for normalized:`, normalizedOption);
                console.log(`Array check result: ${isChecked}`);
                return isChecked;
            }

            // If field value is a single value, check exact match
            const normalizedValue = typeof fieldValue === 'string' ? fieldValue.replace(/[\\'"[\]]/g, '').trim() : String(fieldValue);
            const normalizedOption = optionValue.replace(/[\\'"[\]]/g, '').trim();
            const isChecked = normalizedValue === normalizedOption;
            console.log(`Single value check result: ${isChecked}`);
            return isChecked;
        },

        handleCheckboxChange(fieldId, optionValue, event) {
            const isChecked = event.target.checked;
            let currentValue = this.formData[fieldId];
            
            console.log(`Checkbox change - Field: ${fieldId}, Option: ${optionValue}, Checked: ${isChecked}`);
            console.log(`Current value before change:`, currentValue);

            // Initialize as array if not set
            if (!currentValue || !Array.isArray(currentValue)) {
                currentValue = [];
            }
            
            // Clean the current array - remove any comma-separated strings and flatten
            const cleanedCurrentValue = [];
            currentValue.forEach(val => {
                if (typeof val === 'string') {
                    const cleaned = val.replace(/[\\'"[\]]/g, '').trim();
                    if (cleaned.includes(',')) {
                        cleaned.split(',').forEach(item => {
                            const trimmed = item.trim();
                            if (trimmed) cleanedCurrentValue.push(trimmed);
                        });
                    } else if (cleaned) {
                        cleanedCurrentValue.push(cleaned);
                    }
                } else if (val) {
                    cleanedCurrentValue.push(String(val));
                }
            });

            if (isChecked) {
                // Add to array if not already present
                if (!cleanedCurrentValue.includes(optionValue)) {
                    cleanedCurrentValue.push(optionValue);
                }
            } else {
                // Remove from array (remove all instances)
                const filtered = cleanedCurrentValue.filter(v => v !== optionValue);
                cleanedCurrentValue.length = 0;
                cleanedCurrentValue.push(...filtered);
            }

            // Update the form data with cleaned array
            this.formData[fieldId] = cleanedCurrentValue;

            console.log(`Checkbox ${fieldId} updated to:`, this.formData[fieldId]);
        }
    },
};
</script>

<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

.error-feedback {
    color: red;
    font-size: 12px;
    margin-top: 4px;
}

.edit-btn {
    margin-left: 8px;
}

.progress {
    width: 80px;
}

.listview>li footer {
    color: #171617;
}

.min-width-50 {
    min-width: 60% !important;
}

.action-button-list>li {
    min-height: 1px !important;
}

.sl-no {
    font-weight: 900;
    margin-right: 12px;
}

.deleted-list-title {
    font-size: 15px;
}

.deleted-list {
    margin-bottom: 20px;
}

.deleted-info {
    background-color: #f2bbca;
    font-size: 12px;
}

.deleted-info strong {
    font-size: 18px;
    font-weight: 600;
}

.image-listview.text>li:after {
    left: 0px;
    background-color: #1a418c;
}

/* Basic Details Card Styles - Compact Mobile Layout */
.basic-details-body {
    padding: 10px 12px !important;
}

/* Profile Header - Top Left Layout */
.profile-header-compact {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e9ecef;
    margin-bottom: 8px;
}

.avatar-section-compact {
    flex-shrink: 0;
}

.profile-header-main {
    display: flex;
    align-items: center;
    gap: 8px;
}

.profile-avatar-compact {
    width: 44px;
    height: 44px;
    object-fit: cover;
    border: 2px solid #1a418c;
    border-radius: 50%;
}

.profile-info-compact {
    flex: 1;
    min-width: 0;
}

.profile-name-compact {
    font-size: 14px;
    font-weight: 600;
    color: #1a418c;
    margin-bottom: 0;
    line-height: 1.1;
    word-break: break-word;
}

.profile-mobile-compact {
    font-size: 12px;
    color: #6c757d;
    margin-bottom: 0;
}

.profile-status-compact {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    align-items: center;
    margin-top: 2px;
}

.badge-sm {
    font-size: 9px;
    padding: 2px 6px;
    font-weight: 500;
}

/* Compact Form Fields */
.compact-fields-row {
    margin: 0;
}

.compact-fields-row .col-6 {
    padding-left: 4px;
    padding-right: 4px;
}

.form-group-compact {
    margin-bottom: 6px;
}

.label-compact {
    font-size: 9px;
    font-weight: 500;
    margin-bottom: 2px;
    color: #1a418c;
    display: block;
    line-height: 1.2;
}

.form-control-compact {
    padding: 0;
    background-color: transparent;
    border: 0;
    border-radius: 0;
    min-height: auto;
    display: block;
    font-size: 11px;
    color: #495057;
    word-break: break-word;
    line-height: 1.3;
}

.form-control-compact.membership-status-field {
    justify-content: flex-start;
    gap: 4px;
    background-color: transparent;
    border: 0;
    padding-left: 0;
}

.suggest-edit-btn {
    padding: 0;
    margin: 0;
    color: #1a418c;
    font-size: 18px;
}

.membership-inline {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.membership-inline-value {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
}

.basic-inline-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 12px;
    row-gap: 4px;
}

.basic-inline {
    display: flex;
    align-items: center;
    gap: 6px;
}

.basic-inline-icon {
    font-size: 16px;
    color: #1a418c;
    flex-shrink: 0;
}

.basic-inline-text {
    font-size: 14px;
    color: #495057;
    word-break: break-word;
    font-weight: 500;
    line-height: 1.2;
}

.membership-badge {
    display: inline-block;
    padding: 1px 6px;
    border-radius: 999px;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.2;
}

.membership-badge.text-success {
    background-color: #d1f2d8;
    color: #198754;
}

.membership-badge.text-danger {
    background-color: #f8d7da;
    color: #dc3545;
}

.profile-header-actions {
    display: flex;
    align-items: center;
    gap: 6px;
}

.header-call-btn,
.header-whatsapp-btn {
    padding: 0;
    margin: 0;
    font-size: 18px;
    color: #1a418c;
}

.header-whatsapp-btn {
    color: #25d366;
}

@media (max-width: 360px) {
    .basic-inline-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

/* Call History Styles */
.call-history-card {
    padding: 10px 12px;
}

.call-history-header {
    margin-bottom: 6px;
}

.call-history-title {
    font-size: 13px;
    font-weight: 600;
    color: #1a418c;
}

.call-history-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.call-history-item {
    display: flex;
    align-items: flex-start;
    font-size: 12px;
    color: #495057;
}

.call-history-item + .call-history-item {
    margin-top: 4px;
}

.call-history-timeline {
    position: relative;
    width: 16px;
    display: flex;
    justify-content: center;
}

.call-history-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #ced4da;
    margin-top: 4px;
}

.call-history-dot.active {
    width: 8px;
    height: 8px;
    background-color: #1a418c;
}

.call-history-line {
    position: absolute;
    top: 10px;
    bottom: -6px;
    left: 50%;
    width: 2px;
    transform: translateX(-50%);
    background-color: #e9ecef;
}

.call-history-content {
    flex: 1;
    padding-left: 4px;
}

.call-history-entry {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 6px 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.call-history-entry-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
    margin-bottom: 4px;
}

.call-history-main {
    font-weight: 500;
    color: #212529;
}

.call-history-duration {
    font-size: 11px;
    color: #868e96;
    white-space: nowrap;
}

.call-history-chevron {
    font-size: 14px;
    color: #adb5bd;
}

.call-history-meta {
    font-size: 11px;
    color: #868e96;
    margin-bottom: 2px;
}

.call-history-meta .dot-separator::before {
    content: "• ";
    margin: 0 2px 0 4px;
}

.call-history-section {
    font-size: 11px;
    color: #495057;
}

.call-history-section + .call-history-section {
    margin-top: 2px;
}

.call-history-section-label {
    font-weight: 500;
    margin-right: 2px;
}

.call-history-section-text {
    color: #495057;
}

/* Detail Tabs spacing to align with cards */
.detail-tabs-wrapper {
    padding-left: 8px;
    padding-right: 8px;
}

.detail-tabs {
    margin-left: 4px;
    margin-right: 4px;
}

/* Mobile Optimizations */
@media (max-width: 576px) {
    .basic-details-body {
        padding: 8px 10px !important;
    }
    
    .profile-header-compact {
        gap: 6px;
        padding-bottom: 6px;
        margin-bottom: 6px;
    }
    
    .profile-avatar-compact {
        width: 40px;
        height: 40px;
    }
    
    .profile-name-compact {
        font-size: 15px;
    }
    
    .profile-mobile-compact {
        font-size: 14px;
    }
    
    .compact-fields-row .col-6 {
        padding-left: 3px;
        padding-right: 3px;
    }
    
    .form-group-compact {
        margin-bottom: 5px;
    }
    
    .label-compact {
        font-size: 8px;
    }
    
    .form-control-compact {
        font-size: 10px;
        padding: 2px 5px;
        min-height: 22px;
    }
}

.verification-badge {
    margin-left: 5px;
}

.avatar-section .button {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    position: absolute;
    right: 10px;
    top: 24px;
    bottom: 0;
}

.avatar-section .verified {
    background: #4dc81c;
}

.avatar-section .not-verified {
    background: #eb3941;
}

.green-tick {
    font-size: 18px;
    color: darkgreen;
}

.red-cross {
    font-size: 18px;
    color: red;
}

.qhls-text {
    font-style: italic;
    color: #266bd1;
}

.custom-file-upload {
    position: relative;
    display: flex;
    width: 50%;
    height: 100px;
}

.radio-group,
.checkbox-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 5px;
}

.form-check {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 0;
    padding: 0;
}

.form-check-input {
    margin: 0 !important;
    width: 18px;
    height: 18px;
    flex-shrink: 0;
}

.form-check-label {
    margin: 0 !important;
    padding: 0;
    font-weight: normal;
    cursor: pointer;
    user-select: none;
}

/* For horizontal layout on larger screens */
@media (min-width: 576px) {
    .radio-group,
    .checkbox-group {
        flex-direction: row;
        flex-wrap: wrap;
        gap: 15px;
    }

    .form-check {
        margin-right: 15px;
        margin-bottom: 8px;
    }
}

.custom-select {
    appearance: auto;
    -webkit-appearance: auto;
    -moz-appearance: auto;
}

.compact-item {
    min-height: 50px !important;
    padding: 8px 15px !important;
}

.compact-item .detail {
    align-items: center;
}

.compact-item .detail img {
    width: 32px !important;
    height: 32px !important;
    margin-right: 12px;
}

.compact-item .detail div {
    display: flex;
    align-items: center;
}
</style>

